import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, View, Flex, Button, Card, useTheme } from '@aws-amplify/ui-react';
import { IoMdClose } from "react-icons/io";
import Modal from 'react-modal';
import { useTokens } from '../components/AuthPage'; // AuthPageからuseTokensをインポート
// テーマ
import { ThemeProvider } from '@aws-amplify/ui-react';
import { appTheme } from '../theme/appTheme';
import '../css/CsvDLConfirm.css';

// 検索条件レコード情報
export type SearchFilter = {
    industorialClass:string;
    address:string;
    businessKeywords:string;
    corporateName:string;
    freeWord:string;
    detailParameter:string;
    flag:string;
};

type SearchConcitionModalProps = {
    modalIsOpen: boolean;
    onRequestClose: () => void;
    modalData: SearchFilter;
};

export default function SearchConditionModal(props:SearchConcitionModalProps) {
    const {tokens} = useTheme();
    const navigate = useNavigate();
    
    const { getTokens } = useTokens(); // useTokensフックを使用
    const [tokenInfo, setTokenInfo] = React.useState<any>(null);
    
    const searchFilterRecord:SearchFilter = {...props.modalData};
    
    const onClose = () => {
        props.onRequestClose();
    };
    
    //モーダル幅
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    
    useEffect(() => {
        const handleResize = () => {
          setWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
        
        window.addEventListener('resize', handleResize);
        
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    //テーブルの横幅設定
    const [minWidth, setMinWidth] = useState('1150px');
    
    //テーブル幅設定
    useEffect(() => {
        if (windowDimensions.width < 1100) {
          setMinWidth('1350px');
        } else {
          setMinWidth('950px');
        }
    }, [windowDimensions]);
    
    const getModalWidth = () => {
      if (windowDimensions.width < 1440) {
        return '95%';
      } else {
        return '75%';
      }
    };
    
    const customStyles = {
        content: {
          width: getModalWidth(),
          height: 'auto',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '0',
          border: 'solid',
          borderRadius: "10px",
          borderColor: "rgb(177,177,177)"
        },
        overlay: {
          backgroundColor: 'rgba(177,177,177,0.75)',
          zIndex: 1000,
        }
    };

    return (
        <Modal isOpen={props.modalIsOpen} style={customStyles}>
          <ThemeProvider theme={appTheme}>
            <Flex backgroundColor={tokens.colors.blue[10]} borderRadius="5px" direction="column" justifyContent="center" alignItems="center">
              <View width="100%" textAlign="right">
                  <Button borderStyle="none"  onClick={onClose}><IoMdClose size={24} color="black"/></Button>
              </View>
            </Flex>
            <Flex direction="column" justifyContent="left" padding="20px" width="90%">
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>業種：</Text>{(searchFilterRecord.industorialClass) ? searchFilterRecord.industorialClass : 'なし'}</View>
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>地域：</Text>{(searchFilterRecord.address) ? searchFilterRecord.address : 'なし'}</View>
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>事業内容：</Text>{(searchFilterRecord.businessKeywords) ? searchFilterRecord.businessKeywords : 'なし'}</View>              
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>企業名：</Text>{(searchFilterRecord.corporateName) ? searchFilterRecord.corporateName : 'なし'}</View>
              <View>
                <Text fontSize={tokens.fontSizes.xl} minWidth="5em" fontWeight={tokens.fontWeights.bold}>キーワード：</Text>{(searchFilterRecord.freeWord) ? searchFilterRecord.freeWord : 'なし'}</View>
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>詳細条件：</Text>{(searchFilterRecord.detailParameter) ? searchFilterRecord.detailParameter : 'なし'}</View>
              <View><Text fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>フラグ：</Text>{(searchFilterRecord.flag) ? searchFilterRecord.flag : 'なし'}</View>
            </Flex>
          </ThemeProvider>
        </Modal>
    );
};